import { type ApolloError, useQuery } from '@apollo/react-hooks';
import type { PanelMember } from './types';
import { GET_PANEL_MEMBERS } from './useGetPanelMembers';

type SearchPanelMember = {
  panelMembers: PanelMember[];
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => any;
};

export const useSearchPanelMember = (filter: any): SearchPanelMember => {
  const { data, loading, error, refetch } = useQuery(GET_PANEL_MEMBERS, {
    variables: { filter },
    fetchPolicy: 'network-only',
    skip: !(filter as boolean),
  });

  const members = data?.advancedUsers ?? [];

  const panelMembers: PanelMember[] = members.map((member: any) => {
    const { netId, displayName, surname, givenName, department, email } =
      member ?? {};
    return {
      netId,
      name:
        Boolean(surname) && Boolean(givenName)
          ? `${surname.toUpperCase()}, ${givenName}`
          : displayName,
      dep: department,
      email,
    };
  });

  return {
    panelMembers,
    loading,
    error,
    refetch,
  };
};
